import { Modal } from "react-bootstrap";
import { confirm, date_hint, list_filters, clear_filter } from '../../resources/string/strings'
import { ReactComponent as IconCLose } from "../../resources/image/ic_cross_gray.svg";

export default function VerticalModal(props) {
  var values = new Map(props.values.map(i => [i.id, i.value]));
  return (
    <Modal
      {...props}
      className="modal"
      dir="rtl"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="text-right mr-0 ml-auto" >

        <Modal.Title style={{float: "right"}} className="mr-auto" id="contained-modal-title-vcenter">
          {list_filters}
        </Modal.Title>

        <IconCLose 
             style={{float: "left", color: "GrayText"}}
                    className="p-0 clickable"
                    width="16"
                    height="16"
                    fill="gray"
                    color="gray"
                    onClick={() => props.onHide(false)}
                  />
      </Modal.Header>
      <Modal.Body>


        {props.filters.length !== 0 && (
          <form className="text-right" style={{ direction: `rtl` }} >
            {props.filters.map((item) => (
              <div key={item.id} className="form-group row mb-2">
                <div className="pl-0 pr-4 col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  {item.title}
                </div>
                <div className="pl-0 pr-0 col-6 col-sm-6 col-md-6 col-lg-6 col-xl-5">
                  {item.type === "dropdown" &&
                    <div >
                      <select
                        className="form-control"
                        type="select"
                        value={values.get(item.id)}
                        onChange={(event) => {
                          props.filterchanged(item, event.target.value)
                        }}
                      >

                        {item.items.map((it) => (
                          <option
                            key={it.title}
                            value={it.value === null ? "" : it.value === undefined ? "" : it.value}
                          >
                            {it.title}
                          </option>
                        ))}

                      </select>
                    </div>
                  }

                  {item.type === "text" &&
                    <input
                      className="form-control"
                      type="text"
                      value={values.get(item.id)}
                      placeholder={item.title}
                      onChange={(event) => {
                        props.filterchanged(item, event.target.value)
                      }}
                    />
                  }

                  {item.type === "numberInteger" &&
                    <input
                      className="form-control"
                      type="number"
                      value={values.get(item.id)}
                      placeholder={item.title}
                      onChange={(event) => {
                        props.filterchanged(item, parseInt(event.target.value))
                      }}
                    />
                  }

                  {item.type === "date" &&
                    <input
                      className="form-control"
                      type="text"
                      value={values.get(item.id)}
                      placeholder={date_hint}
                      onChange={(event) => {
                        props.filterchanged(item, event.target.value)
                      }}
                    />
                  }


                </div>

              </div>
            ))}
          </form>
        )}


      </Modal.Body>
      <Modal.Footer className="text-left ml-0 mr-auto">
        <div className="btn btn-warning px-4" onClick={() => {
          props.onHide(false)
          props.clearfilters()
        }}>
          {clear_filter}
        </div>
        <div className="btn btn-primary px-4" onClick={() => props.onHide(true)}>
          {confirm}
        </div>

      </Modal.Footer>
    </Modal>
  );

}
